/* eslint-disable */
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import img from '../../assets/images/success.svg'
import { Button } from '../../components/core/button'
import StepLine from '../../components/core/stepLine'
import { useLocation } from 'react-router-dom'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'

const SuccessDefaultV3 = ({ className }) => {
  const location = useLocation()
  const data1 = [
    {
      title: translate.add_info,
      text: {
        ENG: 'Add address and company name',
        AZ: 'Ünvan və şirkət adını əlavə edin',
        RU: 'Добавьте адрес и название компании',
      },
    },
    {
      title:
        location.pathname === '/success/v3'
          ? {
              AZ: 'Maraqlarınızı qeyd edin',
              ENG: 'Mark your interests',
              RU: 'Отметьте свои интересы',
            }
          : translate.select_service,
      text:
        location.pathname === '/success/v3'
          ? {
              ENG: 'Share your interests with us',
              AZ: 'Maraqlarınızı bizimlə bölüşün',
              RU: 'Поделитесь с нами своими интересами',
            }
          : location.pathname === '/success/v1'
          ? {
              ENG: 'Select the type of service you want to provide',
              AZ: 'Təmin etmək istədiyiniz xidmət növünü seçin',
              RU: 'Выберите тип услуги, которую вы хотите предоставить',
            }
          : {
              ENG: 'Select the type of service you want to receive',
              AZ: 'Almaq istədiyiniz xidmət növünü seçin',
              RU: 'Выберите тип услуги, которую хотите получить',
            },
    },
    {
      title: {
        AZ: 'Finiş',
        ENG: 'Finish',
        RU: 'Финиш',
      },
      text: {
        ENG: 'Your application has been approved',
        AZ: 'Müraciətiniz təsdiqləndi',
        RU: 'Ваша просьба одобрена',
      },
    },
  ]
  const { language } = useContext(PageContext)
  const DEFAULT_DATA = {
    title: {
      AZ: 'Müraciətiniz qəbul edildi',
      ENG: 'Application Received',
      RU: 'Заявка принята',
      TR: 'Başvurunuz Alındı',
    },
    description_az: 'Müraciətiniz uğurla qeydə alındı. Tezliklə sizinlə əlaqə saxlayacağıq.',
    description_eng: 'Your application has been successfully received. We will contact you soon.',
    description_ru: 'Ваша заявка успешно принята. Мы свяжемся с вами в ближайшее время.',
    description_tr: 'Başvurunuz başarıyla kaydedildi. En kısa sürede sizinle iletişime geçeceğiz.',
  }
  const [load, setLoad] = useState(true)
  const [data, setData] = useState(DEFAULT_DATA)
  useEffect(() => {
    (async () => {
      try {
        const res = await PagesAPI.getSuccess()
        if (res?.data?.title) {
          setData(res.data)
        }
      } catch (e) {
        console.warn('Using default success data')
      }
    })()
  }, [])
  const home = {
    AZ: 'Ana Səhifə',
    ENG: 'Home',
    RU: 'Главная страница',
    TR: 'Ana Sayfa',
  }
  return load ? (
    <section className={`${styles.container} ${className}`}>
      <StepLine active={2} data={data1} />

      <div className={styles.content}>
        <img src={img} alt="Success" />
        <h1>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}</h1>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? data?.description_az
                : language === 'TR'
                ? (data?.description_tr || data?.description_az)
                : language === 'ENG'
                ? data?.description_eng
                : (data?.description_ru || data?.description_az),
          }}
        />
        <Button to={'/'}>{home[language] || home.TR || home.AZ}</Button>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default SuccessDefaultV3
